import EditUser from "@/app/shared/roles-permissions/edit-user";
import useProfile from "@/hooks/use-profile";

export default function ProfilePage() {
  const { profile } = useProfile();

  if (!profile) return <></>;
  return <EditUser id={profile?.id} title="Account Settings" />;
}
